import { Component } from '@angular/core';

@Component({
  selector: 'app-cards4-examples-28',
  templateUrl: './cards4-examples-28.component.html'
})
export class Cards4Examples28Component {}
